// extracted by mini-css-extract-plugin
export default {"result__row":"ResultRow_result__row__7UE4e"};